import { Link } from 'react-router-dom';

const footerLinks = {
  articles: {
    title: '記事カテゴリ',
    links: [
      { label: 'STEP1｜知識をつける', href: '/steps/01' },
      { label: 'STEP2｜予算を決める', href: '/steps/02' },
      { label: 'STEP3｜パートナーを選ぶ', href: '/steps/03' },
      { label: 'STEP4｜物件・プランを決める', href: '/steps/04' },
      { label: 'STEP5｜契約・引き渡し', href: '/steps/05' },
    ],
  },
  guide: {
    title: '初心者ガイド',
    links: [
      { label: '住宅購入の流れ', href: '/articles/7' },
      { label: '頭金の考え方', href: '/articles/27' },
      { label: 'ローン審査のコツ', href: '/articles/41' },
      { label: 'よくある失敗例', href: '/articles/9' },
    ],
  },
  site: {
    title: 'サイト情報',
    links: [
      { label: 'このサイトについて', href: '#about' },
      { label: '運営者プロフィール', href: '/profile' },
      { label: 'プライバシーポリシー', href: '/privacy-policy' },
      { label: '免責事項', href: '/disclaimer' },
      { label: '著作権について', href: '/copyright' },
      { label: 'お問い合わせ', href: '/contact' },
    ],
  },
};

export default function Footer() {
  return (
    <footer className="bg-[#F0EBE3]">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/2c450daa-ab1c-4449-ac53-d1ae0dbc5040.png"
                alt="はじめての家づくりガイド"
                className="h-8 w-auto object-contain"
              />
              <span className="text-sm font-bold text-[#2C2C2C]">はじめての<br />家づくりガイド</span>
            </div>
            <p className="text-[#6B6B6B] text-xs leading-relaxed mb-5">
              住宅購入を初めて検討する方に向けて、資金計画・物件選び・住宅ローンなど、失敗しない家づくりの知識をわかりやすく発信するブログです。
            </p>
            <div className="flex gap-3">
              <a
                href="#"
                rel="nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#8FA882] text-white hover:bg-[#7A9570] transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-sm" />
              </a>
              <a
                href="#"
                rel="nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#8FA882] text-white hover:bg-[#7A9570] transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-sm" />
              </a>
              <a
                href="#"
                rel="nofollow"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-[#8FA882] text-white hover:bg-[#7A9570] transition-colors cursor-pointer"
                aria-label="LINE"
              >
                <i className="ri-line-line text-sm" />
              </a>
            </div>
          </div>

          {/* Links */}
          {Object.values(footerLinks).map((section) => (
            <div key={section.title}>
              <h4 className="text-[#2C2C2C] text-xs font-bold uppercase tracking-wider mb-4">
                {section.title}
              </h4>
              <ul className="space-y-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    {link.href.startsWith('/') ? (
                      <Link
                        to={link.href}
                        className="text-[#6B6B6B] text-sm hover:text-[#8FA882] transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    ) : (
                      <a
                        href={link.href}
                        className="text-[#6B6B6B] text-sm hover:text-[#8FA882] transition-colors cursor-pointer"
                      >
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Newsletter subtle callout */}
        <div className="border-t border-[#D8CEC4] pt-8 pb-6">
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 pt-2">
          <p className="text-[#A0A0A0] text-xs">
            &copy; {new Date().getFullYear()} はじめての家づくりガイド. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy-policy" className="text-[#A0A0A0] text-xs hover:text-[#8FA882] transition-colors cursor-pointer">
              プライバシーポリシー
            </Link>
            <span className="text-[#C0B8B0]">|</span>
            <Link to="/disclaimer" className="text-[#A0A0A0] text-xs hover:text-[#8FA882] transition-colors cursor-pointer">
              免責事項
            </Link>
            <span className="text-[#C0B8B0]">|</span>
            <Link to="/copyright" className="text-[#A0A0A0] text-xs hover:text-[#8FA882] transition-colors cursor-pointer">
              著作権について
            </Link>
            <span className="text-[#C0B8B0]">|</span>
            <Link to="/contact" className="text-[#A0A0A0] text-xs hover:text-[#8FA882] transition-colors cursor-pointer">
              お問い合わせ
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
